<script setup lang="ts">
import type { AvatarImageProps } from "reka-ui"
import { AvatarImage } from "reka-ui"

const props = defineProps<AvatarImageProps>()
</script>

<template>
  <!-- `loading`/`decoding` aren't part of `AvatarImageProps`, so they ride through reka-ui's
       `Primitive` (rendered `as: "img"`) via attribute fallthrough. The avatar's own box is already
       fixed by `Avatar`'s `size-*` class, so there's no layout shift to fix here — `decoding="async"`
       is what matters: a channel-open mounts dozens of avatars at once, and one of the profiled
       avatar originals was 1.4MB, decoded synchronously on the main thread alongside every
       attachment. `loading="lazy"` is belt-and-braces (reka-ui hides the element with `v-show`
       until its own `new Image()` preload resolves, so the fetch is usually already warm). -->
  <AvatarImage
    data-slot="avatar-image"
    v-bind="props"
    loading="lazy"
    decoding="async"
    class="aspect-square size-full"
  >
    <slot />
  </AvatarImage>
</template>
